/**
 * 举报类型表格组件
 */
import React, { useMemo } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import type { TRequestBackType } from '@op/utils/requestUtil';
import { DBO_V } from '@op/utils/format';
import useLanguage from '@op/hooks/useLanguage';

interface IReportTypeTableChartProps {
  data?: TRequestBackType;
  height?: number;
  isEn?: boolean;
  list?: any[] | null;
}

const ReportTypeTableChart: React.FC<IReportTypeTableChartProps> = ({
  data,
  height = 350,
  isEn = true,
  list = null,
}) => {
  const { formatMessage } = useLanguage();

  // 获取显示名称 - 根据 isEn 返回英文或中文名
  const getDisplayName = (nameEn: string): string => {
    if (isEn) return nameEn;
    const item = list?.find((i) => i.category_name_en === nameEn);
    return item?.category_name || nameEn;
  };

  // 表格配置（列与可排序列）
  const { columns, sortColumns } = useMemo(() => {
    const cols: any[] = [
      {
        key: 'date',
        header: formatMessage({ id: 'Date' }),
        width: 120,
      },
    ];
    const keys = ['date'];

    // 添加每个系列的列
    data?.series?.forEach((item) => {
      cols.push({
        key: item.name,
        header: getDisplayName(item.name),
        align: 'right',
        width: 180,
        render: (record: any) => DBO_V.reviews(record[item.name] || 0),
      });
      keys.push(item.name);
    });

    return { columns: cols, sortColumns: keys };
  }, [data, formatMessage, list]);

  // 表格数据 - 优先使用 tableRecord
  const records = useMemo(() => {
    return data?.tableRecord || [];
  }, [data]);

  return (
    <TableCommonHook
      className="dbo-report-type-trend__table"
      recordKey="date"
      columns={columns}
      records={records}
      hasPageable={false}
      maxHeight={height}
      // sortType="local"
      // sortColumns={sortColumns}
      defaultSort={{ by: 'date', order: 'desc' }}
      minWidth="auto"
    />
  );
};

export default ReportTypeTableChart;
